import axios from "axios";
import { useNavigate } from 'react-router-dom';

export const axiosInstance = axios.create({
  // baseURL: process.env.REACT_APP_API,
});

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent 
    const token = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}`)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.grant_type = 'ui'
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // const originalRequest = error.config; 
     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
       console.log('login')
      // Redirect to login page and clear session
      localStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}`)
      const navigate = useNavigate(); // Hook must be called within a component or another hook
      navigate('/login'); // Optional: add redirect parameter
    }
    return Promise.reject(error);
     
  }
);

